(function (root) {
  'use strict';
  /* Top picks are the Birthday Club shop API's own order. The backend
     reads the curated reminders-picks collections (relationship and
     occasion first), applies the route, age, alcohol and add-on rules, and
     returns topPicks in that order. Nothing here re-sorts it: the page used
     to fetch the collection in best-selling order, which put greeting
     cards and unrelated best-sellers ahead of the curated gifts.
     A product the shop payload already marks as something the recipient
     likes (evidence.kind, the same kinds the group-gift cards read) is
     placed first, labelled "{Name} loves this.". */
  var PREFERENCE_KINDS = {
    loved: true, recipient_loved: true,
    wishlist: true, recipient_wishlist: true,
    preference: true, recipient_preference: true
  };
  var PREFERENCE_GROUP_ORDER = ['cards', 'gifts', 'flowers'];

  function isPreference(product) {
    var kind = product && product.evidence && product.evidence.kind;
    return !!(product && (product.recipientLoves === true || PREFERENCE_KINDS[kind]));
  }
  /* "Jess loves this." The reminders feature's own name. No stand-in when
     the name is missing: an empty string, and the card shows no label. */
  function lovesLabel(name) {
    var value = String(name == null ? '' : name).trim();
    if (!value) return '';
    return value + ' likes this.';
  }
  function recipientLovesLabel(product, name) {
    if (product && product.evidence && product.evidence.kind === 'sender_preference') return 'From your saved ideas or notes';
    if (!isPreference(product)) return '';
    if (product.evidence && (product.evidence.kind === 'recipient_wishlist' || product.evidence.kind === 'wishlist')) return String(name || '').trim() ? name + ' would like this as a gift.' : '';
    if (product.evidence && (product.evidence.kind === 'recipient_preference' || product.evidence.kind === 'preference')) return String(name || '').trim() ? 'Matches ' + name + '’s preferences.' : '';
    return lovesLabel(name);
  }
  function preferenceProducts(state) {
    var seen = {};
    var out = [];
    function take(list) {
      (list || []).forEach(function (product) {
        if (!product || !product.handle || seen[product.handle] || !isPreference(product)) return;
        seen[product.handle] = true;
        out.push(product);
      });
    }
    if (state && state.topPicks && Array.isArray(state.topPicks.products)) take(state.topPicks.products);
    var groups = ((state && state.groups) || []).slice().sort(function (a, b) {
      function rank(key) {
        var index = PREFERENCE_GROUP_ORDER.indexOf(key);
        return index === -1 ? PREFERENCE_GROUP_ORDER.length : index;
      }
      return rank(a && a.key) - rank(b && b.key);
    });
    groups.forEach(function (group) { if (group && Array.isArray(group.products)) take(group.products); });
    return out;
  }
  function orderPicks(picks, preferences) {
    var seen = {};
    var out = [];
    (preferences || []).forEach(function (product) {
      if (!product || !product.handle || seen[product.handle]) return;
      seen[product.handle] = true;
      var pinned = {};
      Object.keys(product).forEach(function (key) { pinned[key] = product[key]; });
      pinned.recipientLoves = true;
      out.push(pinned);
    });
    (picks || []).forEach(function (product) {
      if (!product || !product.handle || seen[product.handle]) return;
      seen[product.handle] = true;
      out.push(product);
    });
    return out;
  }
  /* The recipient's own likes lead, then the API's Top picks in the order
     it returned them. The API pages stay as they are. */
  function applyRecommendationOrder(state) {
    // New payloads are ranked by the shared recipient selector. Never add or reorder its choices here.
    if (state && state.recommendationStatus) return state;
    var preferences = preferenceProducts(state);
    if (!preferences.length) return state;
    var existing = state.topPicks && Array.isArray(state.topPicks.products) ? state.topPicks : null;
    state.topPicks = {
      key: 'top',
      products: orderPicks(existing ? existing.products : [], preferences),
      hasMore: !!(existing && existing.hasMore),
      nextOffset: existing ? existing.nextOffset : null
    };
    return state;
  }
  root.FBRemindersPicks = {
    isPreference: isPreference,
    lovesLabel: lovesLabel,
    recipientLovesLabel: recipientLovesLabel,
    preferenceProducts: preferenceProducts,
    orderPicks: orderPicks,
    applyRecommendationOrder: applyRecommendationOrder
  };


  var page = root.document && root.document.querySelector('#fb-reminders-app');
  if (!page || !root.FBRemindersAPI) return;
  var params = new URLSearchParams(root.location.search);
  if (params.get('reminder_view') !== 'person' || !params.get('id')) return;
  var id = params.get('id');
  var api = root.FBRemindersAPI.create(page.dataset.apiBase);
  function browsingText(key, fallback) {
    var shop = page.querySelector('[data-reminders-person-shop]');
    return shop && shop.getAttribute('data-browsing-' + key) || fallback;
  }
  var state = null;
  var drawer = page.querySelector('[data-reminders-detail-drawer]');
  var formerFocus = null;
  var pending = false;
  var contextMutationBusy = false;
  var contextWrites = new Set();
  var contextUncertain = false;
  var budgetBusy = false;
  var desiredBudgetBand;
  var confirmedBudgetBand = null;
  var confirmedBudgetCents = null;
  var shopRevision = 0;
  var relationshipBusy = false;
  var desiredRelationship = null;
  var optimisticRelationship = null;
  var confirmedRelationship = null;
  var shopSaveError = null;
  var notesState = { text: '', version: null, loaded: false };
  var notesReadSequence = 0, notesDraftDirty = false, notesDraftVersion = null, notesUncertain = false;
  var railRevision = 0;
  var rails = {};
  var GROUP_ORDER = ['cards', 'gifts', 'flowers'];
  var bands = [
    { key: 'UNDER_50', label: 'Up to $50' },
    { key: 'UNDER_100', label: 'Up to $100' },
    { key: 'UNDER_200', label: 'Up to $200' },
    { key: 'OVER_200', label: 'More than $200' }
  ];
  function one(selector) { return page.querySelector(selector); }
  function node(tag, className, text) { var item = root.document.createElement(tag); if (className) item.className = className; if (text !== undefined) item.textContent = text; return item; }
  function price(cents) { return '$' + (Number(cents) / 100).toFixed(2); }
  function safeShopUrl(path, variantId) {
    try {
      var target = new URL(path, root.location.origin);
      if (target.origin !== root.location.origin || !/^\/(products|collections)\/[a-z0-9][a-z0-9-]*$/.test(target.pathname)) return null;
      if (/^[0-9]+$/.test(variantId || '')) target.searchParams.set('variant', variantId);
      var source = state && state.occasion && state.occasion.links && state.occasion.links.shop;
      if (source) {
        var signed = new URL(source, root.location.origin);
        var occ = signed.searchParams.get('occ');
        if (signed.origin === root.location.origin && occ) target.searchParams.set('occ', occ);
      }
      return target.href;
    } catch (_) { return null; }
  }
  function status(text) { one('[data-reminders-shop-save-status]').textContent = text || ''; }
  function error(text) {
    var slot = one('[data-reminders-detail-error]'); slot.textContent = text || '';
    if (notesUncertain) {
      var compare = node('button', 'fb-preferences__button', 'Compare latest note'); compare.type = 'button';
      compare.addEventListener('click', async function () {
        if (pending) return; compare.disabled = true;
        try {
          var response = await api.request('/friends/' + encodeURIComponent(notesFriendId()) + '/details');
          var latest = notesFromPayload(response);
          if (drawer.hidden) return;
          slot.textContent = 'Latest saved note: ' + latest.text;
          var use = node('button', 'fb-preferences__button', 'Edit latest note'); use.type = 'button';
          use.addEventListener('click', function () {
            var field = one('[data-reminders-detail-notes]'), previous = field.value;
            field.value = latest.text; notesDraftVersion = latest.version; notesDraftDirty = false; notesUncertain = false;
            notesState = { text: latest.text, version: latest.version, loaded: true };
            error('Your previous draft: ' + previous);
          }); slot.appendChild(use);
        } catch (_) { error('We couldn’t load the latest note. Your draft is still here.'); }
      }); slot.appendChild(compare);
    }
  }
  function showDrawer(kind, trigger) {
    formerFocus = trigger || root.document.activeElement;
    drawer.hidden = false;
    root.document.body.style.overflow = 'hidden';
    one('[data-reminders-detail-tell]').hidden = kind !== 'tell';
    one('[data-reminders-detail-request]').hidden = kind !== 'request';
    one('[data-reminders-detail-heading]').textContent = kind === 'tell' ? 'Tell us what they like' : 'Ask them to share';
    error('');
    one('[data-reminders-request-share]').hidden = true;
    one('[data-reminders-request-url]').value = '';
    if (kind === 'tell') {
      notesDraftDirty = false; notesDraftVersion = notesState.version; notesUncertain = false;
      one('[data-reminders-detail-ideas]').value = (state && state.giftIdeas || []).join('\n');
      var notesField = one('[data-reminders-detail-notes]');
      if (notesField) { notesField.value = notesState.text || ''; notesField.disabled = !notesState.loaded; }
      (notesField || one('[data-reminders-detail-ideas]')).focus();
    } else {
      one('[data-reminders-request-picks]').focus();
    }
  }
  function closeDrawer() {
    if (pending) return;
    drawer.hidden = true;
    root.document.body.style.overflow = '';
    if (formerFocus && formerFocus.focus) formerFocus.focus();
  }
  /* The catalogue sends the original upload, often several megabytes. Ask
     Shopify's CDN for a card-sized copy instead. Other hosts pass through. */
  function sizedImage(src, width) {
    try {
      var url = new URL(src);
      if (url.hostname !== 'cdn.shopify.com' && url.pathname.indexOf('/cdn/shop/') !== 0) return src;
      url.searchParams.set('width', String(width));
      return url.href;
    } catch (_) { return src; }
  }
  var cardPresentationCache = new Map();
  var cardPresentationTasks = new WeakMap();
  var cardPresentationObserver = root.IntersectionObserver ? new root.IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      cardPresentationObserver.unobserve(entry.target);
      var task = cardPresentationTasks.get(entry.target);
      if (task) task();
    });
  }, { rootMargin: '200px' }) : null;
  function enhanceCardPresentation(card, product, info) {
    if (!root.DOMParser || !root.fetch) return;
    var note = node('span', 'product-grid-item__note');
    var rating = node('div', 'fb-reminders-person__rating');
    info.appendChild(note);
    card.appendChild(rating);
    var footer = card.querySelector('.fb-reminders-person__product-footer');
    if (footer) card.appendChild(footer);
    function load() {
      var path = new URL(safeShopUrl(product.url)).pathname;
      if (!cardPresentationCache.has(path)) {
        cardPresentationCache.set(path, root.fetch(path + '?section_id=fb-reminders-product-presentation', { credentials: 'same-origin' }).then(function (response) {
          if (!response.ok) throw new Error('Presentation unavailable');
          return response.text();
        }).then(function (html) {
          var doc = new root.DOMParser().parseFromString(html, 'text/html');
          var title = doc.querySelector('.product-grid-item__title');
          var designNote = doc.querySelector('.product-grid-item__note');
          var reviews = doc.querySelector('.product__card--rating, .product__card--rating-empty');
          return { title: title && title.textContent.trim(), note: designNote && designNote.textContent.trim(), reviews: reviews };
        }).catch(function () { return null; }));
      }
      cardPresentationCache.get(path).then(function (presentation) {
        if (!presentation || !card.isConnected) return;
        if (presentation.title) info.querySelector('.fb-reminders-person__product-name').textContent = presentation.title;
        note.textContent = presentation.note || '';
        if (presentation.reviews) rating.appendChild(presentation.reviews.cloneNode(true));
      });
    }
    if (cardPresentationObserver) {
      cardPresentationTasks.set(card, load);
      cardPresentationObserver.observe(card);
    } else load();
  }
  var cartFormSequence = 0;
  async function addProductToCart(add, card, href, message) {
    if (add.disabled) return;
    var buttonLabel = add.textContent;
    add.disabled = true;
    add.textContent = 'Adding…';
    message.textContent = '';
    try {
      var url = new URL(href);
      url.searchParams.set('view', 'quickview');
      var response = await root.fetch(url.pathname + url.search);
      if (!response.ok) throw new Error('Couldn’t load this item. Please try again.');
      var html = new root.DOMParser().parseFromString(await response.text(), 'text/html');
      if (!add.isConnected) return;
      var productBody = html.querySelector('.quick_view__body');
      var productForm = productBody && productBody.querySelector('product-form');
      var form = productForm && productForm.querySelector('form');
      var submit = form && form.querySelector('[type="submit"]');
      var variant = form && form.querySelector('input[name="id"]');
      if (!submit || submit.disabled || !variant || (url.searchParams.get('variant') && variant.value !== url.searchParams.get('variant'))) {
        throw new Error('This option is unavailable. Open quick view to see the current choices.');
      }
      if (!root.customElements.get('product-form')) throw new Error('Couldn’t add this item. Please reload and try again.');
      // Reuse Shopify's rendered form and the theme's delivery/date/cart gates.
      // Keep the requested variant and line properties, without inserting a drawer.
      Array.from(productBody.attributes).forEach(function (attribute) {
        if (attribute.name.indexOf('data-') === 0) card.setAttribute(attribute.name, attribute.value);
      });
      var inputs = Array.from(form.querySelectorAll('input[type="hidden"]'));
      form.replaceChildren.apply(form, inputs);
      form.id = 'reminder-cart-' + (++cartFormSequence);
      submit.className = 'fb-reminders-person__product-action product-form__submit';
      submit.setAttribute('aria-label', add.getAttribute('aria-label'));
      submit.replaceChildren(node('span', 'button-text', buttonLabel));
      form.appendChild(submit);
      productForm.className = 'fb-reminders-person__cart-form';
      add.replaceWith(productForm);
      submit.focus();
      form.requestSubmit(submit);
    } catch (cause) {
      message.textContent = cause && cause.message || 'Couldn’t add this item. Please try again.';
    } finally {
      add.disabled = false;
      add.textContent = buttonLabel;
    }
  }
  function productCard(product, eager) {
    var href = safeShopUrl(product.url, product.variantId); if (!href) return null;
    var card = node('article', 'fb-reminders-person__product');
    card.addEventListener('focusin', function () {
      card.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
    });
    var link = node('a', 'fb-reminders-person__product-link'); link.href = href;
    link.setAttribute('data-reminders-quick-view', '');
    link.setAttribute('aria-haspopup', 'dialog');
    link.dataset.productHandle = new URL(href).pathname.split('/')[2];
    link.dataset.productUrl = href;
    var media = node('span', 'fb-reminders-person__product-media');
    var image = node('img'); image.alt = product.imageAlt || product.title;
    var sized = sizedImage(product.image, 480);
    if (sized !== product.image) {
      image.srcset = [240, 360, 480, 720, 960].map(function (w) { return sizedImage(product.image, w) + ' ' + w + 'w'; }).join(', ');
      image.sizes = '(min-width: 990px) 320px, (min-width: 750px) 30vw, 80vw';
    }
    image.src = sized;
    // The first cards of Top picks are on screen as the view opens.
    if (eager) { image.loading = 'eager'; image.setAttribute('fetchpriority', 'high'); }
    else image.loading = 'lazy';
    image.decoding = 'async'; image.width = 480; image.height = 600;
    media.appendChild(image);
    var loves = root.FBRemindersPicks.recipientLovesLabel(product, state.occasion && state.occasion.name);
    if (loves) {
      card.classList.add('fb-reminders-person__product--recipient');
      media.appendChild(node('span', 'fb-reminders-person__recipient-badge', loves));
    }
    link.appendChild(media);
    var info = node('span', 'fb-reminders-person__product-info');
    var productName = node('span', 'fb-reminders-person__product-name', product.title);
    productName.setAttribute('title', product.title);
    info.appendChild(productName);
    link.appendChild(info);
    card.appendChild(link);
    var footer = node('div', 'fb-reminders-person__product-footer');
    var add = node('button', 'fb-reminders-person__product-action', 'Add to cart ' + price(product.priceCents).replace(/\.00$/, ''));
    add.type = 'button';
    add.setAttribute('aria-label', 'Add ' + product.title + ' to cart, ' + price(product.priceCents));
    var message = node('p', 'fb-reminders-person__cart-status');
    message.setAttribute('role', 'status');
    add.addEventListener('click', function () { addProductToCart(add, card, href, message); });
    footer.appendChild(add);
    footer.appendChild(message);
    card.appendChild(footer);
    enhanceCardPresentation(card, product, info);
    if (root.FBWishlistIntent && state.occasion && state.occasion.friendId) {
      var idea = node('button', 'fb-preferences__button', 'Save to my ideas'); idea.type = 'button';
      idea.addEventListener('click', async function () {
        if (idea.disabled) return; idea.disabled = true; message.textContent = 'Saving your private idea…';
        try {
          var path = '/friends/' + encodeURIComponent(state.occasion.friendId) + '/items';
          var existing = await api.request(path);
          var saved = existing.items.find(function (row) { return row.handle === product.handle; });
          if (!saved || saved.status !== 'active') await api.request(path, { method: 'POST', body: root.FBWishlistIntent.body(saved || { handle: product.handle, version: 0 }, saved && saved.intention || 'favourite', 'active') });
          message.textContent = 'Saved to your ideas. Only you can see this.';
          var docEvent = new root.CustomEvent('fb-private-ideas:updated', { detail: { friendId: state.occasion.friendId } }); root.document.dispatchEvent(docEvent);
        } catch (_) { message.textContent = 'We couldn’t save this idea. Try again.'; }
        finally { idea.disabled = false; }
      }); footer.appendChild(idea);
    }
    return card;
  }
  function collectionCard(holder, path, label) {
    var href = safeShopUrl(path);
    if (!href || !/^\/collections\//.test(new URL(href).pathname) || !holder.childNodes.length) return null;
    var link = node('a', 'fb-reminders-person__collection-more');
    link.href = href;
    link.appendChild(node('span', 'fb-reminders-person__collection-more-title', label));
    link.appendChild(node('span', '', 'Explore the full collection'));
    var arrow = node('span', 'fb-reminders-person__collection-more-arrow', '→');
    arrow.setAttribute('aria-hidden', 'true'); link.appendChild(arrow);
    link.addEventListener('focus', function () { link.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' }); });
    holder.appendChild(link);
    return link;
  }
  function occasionCollection() {
    var seasonal = {
      CHRISTMAS: ['christmas', 'Christmas gifts'], VALENTINES_DAY: ['valentines-day', 'Valentine’s Day gifts'],
      MOTHERS_DAY: ['mothers-day', 'Mother’s Day gifts'], FATHERS_DAY: ['fathers-day', 'Father’s Day gifts']
    }[state.occasion.type];
    return seasonal ? { url: '/collections/' + seasonal[0], label: 'See more ' + seasonal[1] } :
      { url: state.occasion.links && state.occasion.links.shop || '/collections/gifts', label: 'See more gifts' };
  }
  function renderProducts() {
    var holder = one('[data-reminders-shop-groups]'); holder.textContent = '';
    railRevision += 1;
    if (cardPresentationObserver) cardPresentationObserver.disconnect();
    rails = {};
    var groups = state.groups && state.groups.length ? state.groups : [
      { key: 'cards', products: [], moreUrl: '/collections/greeting-cards' },
      { key: 'gifts', products: [], moreUrl: '/collections/gifts' },
      { key: 'flowers', products: [], moreUrl: '/collections/flowers' }
    ];
    // Under Top picks: cards, then gifts, then flowers.
    groups = groups.slice().sort(function (a, b) { return GROUP_ORDER.indexOf(a.key) - GROUP_ORDER.indexOf(b.key); });
    var name = state.occasion.name;
    var shown = 0;
    var cards = groups.find(function (group) { return group.key === 'cards'; });
    var legacyTop = (cards ? cards.products.slice(0, 2) : []).concat(groups.filter(function (group) { return group.key !== 'cards'; }).flatMap(function (group) { return group.products; })).slice(0, 3);
    var topPage = state.topPicks && Array.isArray(state.topPicks.products) ? state.topPicks : { key: 'top', products: legacyTop, hasMore: false, nextOffset: null };
    var topSection = one('[data-reminders-top-picks-section]');
    var topHolder = one('[data-reminders-top-picks]'); topHolder.textContent = '';
    topHolder.setAttribute('aria-label', 'Top picks for ' + name);
    topSection.querySelectorAll('[data-reminders-top-rail-control]').forEach(function (control) { control.remove(); });
    one('[data-reminders-top-picks-name]').textContent = name;
    renderLoves(name);
    topPage.products.forEach(function (product, index) { var card = productCard(product, index < 2); if (card) topHolder.appendChild(card); });
    topSection.hidden = !topHolder.childNodes.length;
    if (!topSection.hidden) {
      var topLoading = node('p', 'fb-reminders-person__rail-status');
      topLoading.dataset.remindersTopRailControl = ''; topLoading.setAttribute('role', 'status'); topLoading.hidden = true;
      topSection.appendChild(topLoading);
      var topRetry = node('button', 'fb-reminders-text-action', 'Try loading more');
      topRetry.dataset.remindersTopRailControl = ''; topRetry.type = 'button'; topRetry.hidden = true;
      topSection.appendChild(topRetry);
      var topRail = { key: 'top', node: topHolder, loading: topLoading, retry: topRetry, nextOffset: topPage.nextOffset, hasMore: !!topPage.hasMore, seen: new Set(topPage.products.map(function (product) { return product.handle; })), busy: false, revision: railRevision };
      rails.top = topRail;
      var morePicks = one('[data-reminders-more-picks]');
      if (!morePicks) { morePicks = node('button', 'fb-reminders-text-action', browsingText('more-gifts', 'Show more gifts')); morePicks.type = 'button'; morePicks.setAttribute('data-reminders-more-picks', ''); topSection.appendChild(morePicks); }
      morePicks.className = 'fb-reminders-person__more-button';
      morePicks.hidden = !topRail.hasMore;
      topRail.more = morePicks;
      morePicks.onclick = function () { loadRail(topRail); };
      topHolder.onscroll = null;
      topRetry.addEventListener('click', function () { loadRail(topRail); });

    }
    groups.forEach(function (group) {
      if (!group.products.length) return;
      if (['CHRISTMAS', 'VALENTINES_DAY', 'MOTHERS_DAY', 'FATHERS_DAY'].includes(state.occasion.type || page.dataset.occasionType) && group.key !== 'cards') return;
      shown += group.products.length;
      var section = node('section', 'fb-reminders-person__group');
      var title = group.key === 'flowers' ? 'Flowers' : group.key === 'cards' ? 'Cards' : 'Gifts';
      section.appendChild(node('h2', '', title + ' for ' + name));
      var products = node('div', 'fb-reminders-person__products');
      products.setAttribute('aria-label', title + ' recommendations for ' + name);
      group.products.forEach(function (product) { var card = productCard(product); if (card) products.appendChild(card); });
      if (group.products.length) {
        section.appendChild(products);
        var loading = node('p', 'fb-reminders-person__rail-status');
        loading.setAttribute('role', 'status');
        loading.hidden = true;
        section.appendChild(loading);
        var retry = node('button', 'fb-reminders-text-action', 'Try loading more');
        retry.type = 'button'; retry.hidden = true;
        section.appendChild(retry);
        var rail = { key: group.key, node: products, loading: loading, retry: retry, nextOffset: group.nextOffset, hasMore: !!group.hasMore, seen: new Set(group.products.map(function (product) { return product.handle; })), busy: false, revision: railRevision };
        rails[group.key] = rail;
        products.addEventListener('scroll', function () { maybeLoadRail(rail); }, { passive: true });
        retry.addEventListener('click', function () { loadRail(rail); });
        rail.end = collectionCard(products, group.moreUrl, 'See more ' + title.toLowerCase());
      }
      else section.appendChild(node('p', '', state.budgetCents == null && !state.budgetBand ? 'No current picks here yet. Browse the full range.' : 'No picks in this category fit your selected range right now. Browse the full range or choose another range.'));
      var more = safeShopUrl(group.moreUrl);
      if (more) { var browse = node('a', 'fb-reminders-person__more-button', 'See more ' + title.toLowerCase()); browse.href = more; section.appendChild(browse); }
      holder.appendChild(section);
    });
    var empty = one('[data-reminders-shop-empty]');
    empty.hidden = shown !== 0 || topHolder.childNodes.length !== 0;
    if (state.recommendationStatus === 'loading') empty.textContent = 'Updating picks…';
    else if (state.recommendationStatus === 'context-unavailable') empty.textContent = browsingText('context-unavailable', 'Personal picks couldn’t load. You can still explore the collection.');
    else if (!state.catalogueAvailable) empty.textContent = browsingText('catalogue-unavailable', 'Gift suggestions couldn’t load. Please try again, or explore the collection.');
    else if (state.budgetCents == null && !state.budgetBand) empty.textContent = browsingText('no-picks', 'We’re finding more gifts for this occasion. Explore the collection for more ideas.');
    else empty.textContent = state.emptyReason === 'budget' ? browsingText('budget-empty', 'No current picks fit this price range.') : browsingText('preferences-empty', 'No current picks match this price range and preferences.');
    if (!empty.hidden && state.catalogueAvailable && (state.budgetBand || state.budgetCents != null)) {
      var changeBudget = node('button', 'fb-reminders-text-action', browsingText('change-budget', 'Change budget')); changeBudget.type = 'button';
      changeBudget.addEventListener('click', function (event) { event.stopPropagation(); one('[data-reminders-shop-plan]').open = true; one('[data-reminders-budget-summary]').focus(); });
      empty.appendChild(changeBudget);
    }
    if (!state.catalogueAvailable && state.recommendationStatus !== 'loading') {
      var retrySuggestions = node('button', 'fb-preferences__button', 'Retry suggestions'); retrySuggestions.type = 'button';
      retrySuggestions.addEventListener('click', function () { retrySuggestions.disabled = true; contextUncertain = false; refresh().finally(function () { retrySuggestions.disabled = false; }); }); empty.appendChild(retrySuggestions);
    }
    var above = one('[data-reminders-shop-over-budget]');
    above.hidden = !state.aboveBudget || !state.aboveBudget.length;
    if (!above.hidden) above.textContent = name + ' saved a favourite above this budget. You can view it by changing your budget.';
    var unavailable = one('[data-reminders-shop-unavailable]');
    unavailable.hidden = !state.unavailableFavourites || !state.unavailableFavourites.length;
    if (!unavailable.hidden) unavailable.textContent = 'A saved favourite (' + state.unavailableFavourites.map(function (item) { return item.title; }).join(', ') + ') is not available today. The choices above are current alternatives.';
  }
  /* Recipient-owned choices retain their wish/favourite evidence on each card.
     The heading identifies the person; the labels explain the different meanings. */
  function renderLoves(name) {
    var section = one('[data-reminders-loves-section]');
    if (!section) return;
    var holder = one('[data-reminders-loves]'); holder.textContent = '';
    var loves = state.recipientLoves || {};
    one('[data-reminders-loves-name]').textContent = name;
    (Array.isArray(loves.products) ? loves.products : []).forEach(function (product, index) {
      var card = productCard(product, index < 2);
      if (card) holder.appendChild(card);
    });
    holder.hidden = !holder.childNodes.length;
    var collection = occasionCollection();
    collectionCard(holder, collection.url, collection.label);
    var note = one('[data-reminders-loves-note]');
    var words = typeof loves.notes === 'string' ? loves.notes.trim() : '';
    note.hidden = !words;
    note.textContent = words ? '“' + words + '”' : '';
    section.hidden = holder.hidden && !words;
  }
  function maybeLoadRail(rail) {
    if (!rail.hasMore || rail.busy || !rail.node.firstElementChild) return;
    var threshold = rail.node.firstElementChild.getBoundingClientRect().width * 2;
    if (rail.node.scrollLeft + rail.node.clientWidth >= rail.node.scrollWidth - threshold) loadRail(rail);
  }
  async function loadRail(rail) {
    if (!rail.hasMore || rail.busy || rail.revision !== railRevision || !Number.isSafeInteger(rail.nextOffset)) return;
    var trigger = root.document.activeElement;
    var focusControl = trigger === rail.more || trigger === rail.retry ? trigger : null;
    rail.busy = true;
    // Keep a focused retry in the tab order until there is a new focus target.
    if (focusControl !== rail.retry) rail.retry.hidden = true;
    rail.loading.hidden = false;
    rail.loading.textContent = 'Loading more…';
    try {
      var response = await api.getShopPage(id, rail.key, rail.nextOffset);
      if (rail.revision !== railRevision) return;
      var page = response && response.group;
      if (!page || page.key !== rail.key || !Array.isArray(page.products) || typeof page.hasMore !== 'boolean' || (page.hasMore && (!Number.isSafeInteger(page.nextOffset) || page.nextOffset <= rail.nextOffset))) throw new Error('Could not load more.');
      var endFocused = rail.end && root.document.activeElement === rail.end;
      if (rail.end) rail.end.remove();
      var firstAdded = null;
      page.products.forEach(function (product) {
        if (rail.seen.has(product.handle)) return;
        var card = productCard(product);
        if (card) { rail.node.appendChild(card); rail.seen.add(product.handle); if (!firstAdded) firstAdded = card; }
      });
      if (focusControl && root.document.activeElement === focusControl) {
        // Appended cards precede the paging controls. Continue through them,
        // but do not pull focus back if the shopper moved away while loading.
        var target = firstAdded || ((!page.hasMore || focusControl === rail.retry) && rail.node.lastElementChild);
        if (target) target.querySelector('a').focus();
        else if (focusControl === rail.retry && rail.more) rail.more.focus();
      }
      rail.hasMore = page.hasMore;
      if (rail.more) rail.more.hidden = !page.hasMore;
      rail.retry.hidden = true;
      rail.nextOffset = page.nextOffset;
      var count = rail.node.childElementCount;
      rail.loading.textContent = browsingText(count === 1 ? 'gifts-shown-one' : 'gifts-shown-many', count === 1 ? 'Showing {count} gift.' : 'Showing {count} gifts.').replace('{count}', count);
      if (rail.end) {
        rail.node.appendChild(rail.end);
        if (endFocused) rail.end.focus();
      }
    } catch (_) {
      if (rail.revision !== railRevision) return;
      rail.loading.textContent = 'More choices could not load.';
      rail.retry.hidden = false;
    } finally { rail.busy = false; }
  }
  function renderBudget() {
    one('[data-reminders-budget-name]').textContent = state.occasion.name;
    try {
      var context = JSON.parse(root.sessionStorage.getItem('fb_rem_ctx') || 'null');
      var signed = state.occasion.links && state.occasion.links.shop;
      var token = signed ? new URL(signed, root.location.origin).searchParams.get('occ') : null;
      if (context && token && context.ctx === token) {
        context.budgetCents = state.budgetCents;
        context.budgetBand = state.budgetBand || null;
        context.returnUrl = '/pages/reminders?reminder_view=person&id=' + encodeURIComponent(id);
        root.sessionStorage.setItem('fb_rem_ctx', JSON.stringify(context));
      }
    } catch (_) {}
    var chosen = bands.find(function (band) { return band.key === state.budgetBand; });
    var summary = one('[data-reminders-budget-summary]');
    if (summary) summary.textContent = chosen ? chosen.key === 'OVER_200' ? '$200+' : chosen.label.replace('Up to ', '') : state.budgetCents != null ? price(state.budgetCents).replace(/\.00$/, '') : browsingText('any-budget', 'No limit');
    var ranges = one('[data-reminders-budget-ranges]');
    if (!ranges.childElementCount) bands.forEach(function (band) {
      var button = node('button', '', band.label); button.type = 'button'; button.dataset.budgetBand = band.key;
      ranges.appendChild(button);
    });
    ranges.querySelectorAll('[data-budget-band]').forEach(function (button) {
      button.setAttribute('aria-pressed', state.budgetBand === button.dataset.budgetBand ? 'true' : 'false');
      var band = bands.find(function (item) { return item.key === button.dataset.budgetBand; });
      button.textContent = band.label;
    });
    var browse = one('[data-reminders-budget-browse]');
    var noBudget = state.budgetBand == null && state.budgetCents == null;
    if (noBudget && root.document.activeElement === browse) summary.focus();
    browse.hidden = noBudget;
  }
  function renderExploreLinks() {
    page.querySelectorAll('[data-reminders-explore-link]').forEach(function (link) {
      var href = safeShopUrl(link.getAttribute('href'));
      if (href) link.href = href;
    });
  }
  function render() {
    one('[data-reminders-shop-plan]').hidden = false;
    one('[data-reminders-person-shop]').hidden = false;
    one('[data-reminders-shop-loading]').hidden = true;
    var relation = one('[data-reminders-relationship]');
    if (state.relationship && !Array.from(relation.options).some(function (option) { return option.value === state.relationship; })) {
      relation.appendChild(node('option', '', state.relationship));
    }
    relation.value = relationshipBusy ? optimisticRelationship : state.relationship || '';
    page.dispatchEvent(new CustomEvent('fb-reminders:relationship', { detail: { relationship: relation.value || null } }));
    renderBudget(); renderExploreLinks(); renderProducts();
    ['picks', 'address', 'birthday'].forEach(function (detail) {
      var label = one('[data-reminders-status-' + detail + ']');
      if (label) label.textContent = (state.request && state.request[detail]) || 'Not requested';
    });
    var birthdayOption = one('[data-reminders-request-birthday]');
    birthdayOption.parentElement.hidden = !state.birthdayRequestAvailable;
    if (!state.birthdayRequestAvailable) birthdayOption.checked = false;
  }
  function invalidateRecommendations(failed) {
    shopRevision += 1;
    state = Object.assign({ occasion: { name: 'this person', friendId: null } }, state, { recommendationStatus: failed || contextUncertain ? 'context-unavailable' : 'loading', catalogueAvailable: false, groups: [], topPicks: { products: [] }, recipientLoves: { products: [], notes: null } });
    renderProducts();
    renderBudget();
    one('[data-reminders-person-shop]').hidden = false;
    one('[data-reminders-shop-loading]').hidden = true;
  }
  root.document.addEventListener('fb-recipient-context:mutation', function (event) {
    var detail = event.detail, scope = detail && detail.scope;
    if (!scope) return;
    // Before the first shop read we cannot identify its friend; hold all friend
    // writes conservatively until a fresh authoritative context can be read.
    var matches = scope.kind === 'all' || (scope.kind === 'occasion' && scope.id === id) || (scope.kind === 'friend' && (!state || !state.occasion || !state.occasion.friendId || scope.id === state.occasion.friendId));
    if (detail.phase === 'begin' && matches) { contextWrites.add(detail.id); invalidateRecommendations(); }
    if (detail.phase === 'settled' && contextWrites.has(detail.id)) {
      contextWrites.delete(detail.id);
      if (!detail.ok) contextUncertain = true;
      invalidateRecommendations();
      if (!contextWrites.size && !contextUncertain) refresh();
    }
  });
  root.document.addEventListener('visibilitychange', function () {
    if (root.document.visibilityState === 'visible' && state) { invalidateRecommendations(); refresh(); }
  });
  root.document.addEventListener('fb-recipient-preferences:updated', function (event) {
    if (!state || !event.detail || event.detail.friendId !== state.occasion.friendId) return;
    invalidateRecommendations(); refresh();
  });
  async function refresh() {
    if (contextWrites.size || contextUncertain) return false;
    var revision = ++shopRevision;
    try {
      var next = await api.getShop(id);
      if (revision !== shopRevision || budgetBusy || relationshipBusy || contextMutationBusy || contextWrites.size || contextUncertain) return false;
      root.FBRemindersPicks.applyRecommendationOrder(next);
      state = next;
      confirmedBudgetBand = next.budgetBand || null;
      confirmedBudgetCents = next.budgetCents == null ? null : next.budgetCents;
      confirmedRelationship = next.relationship || '';
      render();
      loadNotes();
      return true;
    }
    catch (cause) {
      if (revision !== shopRevision || budgetBusy || relationshipBusy || contextMutationBusy || contextWrites.size || contextUncertain) return false;
      invalidateRecommendations(true);
      one('[data-reminders-shop-loading]').textContent = 'Recommendations are unavailable right now. You can still browse the collection.';
      one('[data-reminders-person-shop]').hidden = false;
      status(cause && cause.message || 'Please try again.');
      return false;
    }
  }
  async function flushBudget() {
    if (budgetBusy) return;
    budgetBusy = true;
    while (desiredBudgetBand !== undefined) {
      var band = desiredBudgetBand;
      desiredBudgetBand = undefined;
      try {
        await api.patchShop(id, typeof band === 'number' ? { budgetCents: band } : { budgetBand: band });
        confirmedBudgetBand = typeof band === 'number' ? null : band;
        confirmedBudgetCents = typeof band === 'number' ? band : null;
      } catch (cause) {
        if (desiredBudgetBand !== undefined) continue;
        state.budgetBand = confirmedBudgetBand;
        state.budgetCents = confirmedBudgetCents;
        renderBudget();
        shopSaveError = cause && cause.message || 'Could not save. Try again.';
      }
    }
    budgetBusy = false;
    if (!relationshipBusy) {
      // A failed mutation deliberately blocks refresh until the shopper retries.
      // Report the save result independently so that guard cannot hide an error.
      status(shopSaveError || 'Saved.');
      if (await refresh() && !shopSaveError) {
        var plan = one('[data-reminders-shop-plan]');
        var restoreFocus = plan.open && root.document.activeElement && plan.contains(root.document.activeElement);
        plan.open = false;
        if (restoreFocus) one('[data-reminders-budget-summary]').focus();
      }
    }
  }
  function selectBudget(band) {
    var custom = typeof band === 'number' && Number.isSafeInteger(band) && band >= 1000 && band <= 1000000;
    if (!state || (!custom && band !== null && !bands.some(function (item) { return item.key === band; }))) return;
    shopSaveError = null;
    state.budgetBand = custom ? null : band;
    state.budgetCents = custom ? band : null;
    invalidateRecommendations();
    desiredBudgetBand = band;
    renderBudget();
    status('Updating picks…');
    flushBudget();
  }
  async function flushRelationship() {
    if (relationshipBusy) return;
    relationshipBusy = true;
    while (desiredRelationship !== null) {
      var chosen = desiredRelationship;
      desiredRelationship = null;
      status('Saving…');
      try {
        await api.patchShop(id, { relationship: chosen || null });
        confirmedRelationship = chosen;
      } catch (cause) {
        if (desiredRelationship !== null) continue;
        optimisticRelationship = confirmedRelationship || '';
        state.relationship = optimisticRelationship;
        one('[data-reminders-relationship]').value = optimisticRelationship;
        page.dispatchEvent(new CustomEvent('fb-reminders:relationship', { detail: { relationship: optimisticRelationship || null } }));
        shopSaveError = cause && cause.message || 'Could not save. Try again.';
      }
    }
    relationshipBusy = false;
    if (!budgetBusy) { status(shopSaveError || 'Saved.'); await refresh(); }
  }
  function selectRelationship(chosen) {
    if (!state) return;
    shopSaveError = null;
    invalidateRecommendations();
    optimisticRelationship = chosen;
    desiredRelationship = chosen;
    page.dispatchEvent(new CustomEvent('fb-reminders:relationship', { detail: { relationship: chosen || null } }));
    flushRelationship();
  }
  function notesFriendId() {
    return state && state.occasion && state.occasion.friendId || '';
  }
  function notesFromPayload(payload) {
    if (root.FBPersonNotes && root.FBPersonNotes.notesFromDetails) return root.FBPersonNotes.notesFromDetails(payload);
    var notes = payload && payload.details && payload.details.notes;
    return { text: notes && typeof notes.text === 'string' ? notes.text : '', version: notes ? notes.version : null };
  }
  function rememberNotes(text) {
    var friend = notesFriendId();
    var value = String(text || '');
    try {
      if (root.sessionStorage && root.sessionStorage.setItem) {
        root.sessionStorage.setItem('fb_rem_person_notes', JSON.stringify({ friendId: friend, notesText: value }));
        var raw = root.sessionStorage.getItem('fb_rem_ctx');
        if (raw) {
          var context = JSON.parse(raw);
          if (context && context.ctx && (!context.friendId || !friend || context.friendId === friend)) {
            context.notesText = value;
            if (friend) context.friendId = friend;
            root.sessionStorage.setItem('fb_rem_ctx', JSON.stringify(context));
          }
        }
      }
    } catch (_) {}
    try { root.document.dispatchEvent(new root.CustomEvent('fb-person-notes:updated')); } catch (_) {}
  }
  function renderNotesPreview() {
    var slot = one('[data-reminders-notes-preview]');
    if (!slot || !notesState.loaded) return;
    slot.textContent = root.FBPersonNotes && root.FBPersonNotes.rowPreview
      ? root.FBPersonNotes.rowPreview(notesState.text)
      : (String(notesState.text || '').trim() ? String(notesState.text || '').trim() + ' Edit' : 'Add a note — allergies, pets, colours, what they said last time.');
  }
  async function loadNotes() {
    var friend = notesFriendId();
    if (!friend || !api.request) return;
    var sequence = ++notesReadSequence;
    try {
      var response = await api.request('/friends/' + encodeURIComponent(friend) + '/details');
      if (notesFriendId() !== friend || sequence !== notesReadSequence) return;
      var notes = notesFromPayload(response);
      notesState = { text: notes.text || '', version: notes.version, loaded: true };
      var field = one('[data-reminders-detail-notes]');
      if (field && !notesDraftDirty && !pending && !notesUncertain) { field.value = notesState.text; field.disabled = false; notesDraftVersion = notesState.version; }
      rememberNotes(notesState.text);
      renderNotesPreview();
    } catch (_) {}
  }
  async function saveTell(ideas, notesText) {
    if (pending || notesUncertain) return false;
    pending = true; ++notesReadSequence;
    ['[data-reminders-detail-notes]', '[data-reminders-detail-ideas]', '[data-reminders-detail-save]'].forEach(function (selector) { var field = one(selector); if (field) field.disabled = true; });
    status('Saving…');
    try {
      var friend = notesFriendId();
      if (notesText !== null && (!friend || typeof api.request !== 'function')) {
        status('Personal notes could not be saved. Try again.');
        return false;
      }
      if (notesText !== null) {
        contextMutationBusy = true;
        invalidateRecommendations();
        var version = notesDraftVersion == null ? notesState.version : notesDraftVersion;
        if (!notesState.loaded || version == null) {
          var loaded = await api.request('/friends/' + encodeURIComponent(friend) + '/details');
          version = notesFromPayload(loaded).version;
        }
        var body = root.FBPersonNotes && root.FBPersonNotes.detailsBody
          ? root.FBPersonNotes.detailsBody(notesText, version)
          : { notes: { text: notesText, version: version } };
        var saved = await api.request('/friends/' + encodeURIComponent(friend) + '/details', { method: 'PATCH', body: body });
        var next = notesFromPayload(saved);
        notesState = {
          text: saved && saved.details && saved.details.notes && typeof saved.details.notes.text === 'string' ? next.text : notesText,
          version: next.version != null ? next.version : version,
          loaded: true
        };
        notesDraftVersion = notesState.version; notesDraftDirty = false;
        rememberNotes(notesState.text);
        renderNotesPreview();
        contextMutationBusy = false;
        invalidateRecommendations();
      }
      await api.patchShop(id, { giftIdeas: ideas });
      status('Saved.');
      await refresh();
      return true;
    } catch (cause) {
      if (notesText !== null && contextMutationBusy) notesUncertain = true;
      status(cause && cause.code === 'EDIT_CONFLICT'
        ? 'These notes changed in another tab. Your draft is still here.'
        : (cause && cause.message || 'Could not save. Try again.'));
      return false;
    } finally {
      if (contextMutationBusy) invalidateRecommendations();
      contextMutationBusy = false;
      pending = false;
      ['[data-reminders-detail-notes]', '[data-reminders-detail-ideas]', '[data-reminders-detail-save]'].forEach(function (selector) { var field = one(selector); if (field) field.disabled = false; });
    }
  }
  page.addEventListener('input', function (event) { if (event.target.matches('[data-reminders-detail-notes]')) notesDraftDirty = true; });
  page.addEventListener('click', function (event) {
    var action = event.target.closest('[data-reminders-person-tell-us], [data-reminders-person-ask-wishlist], [data-reminders-person-ask-address], [data-reminders-person-ask-birthday]');
    if (action) {
      event.preventDefault();
      if (action.hasAttribute('data-reminders-person-ask-wishlist')) { root.location.href = '/pages/wishlist-rewards' + (state && state.occasion && state.occasion.friendId ? '?person=' + encodeURIComponent(state.occasion.friendId) : ''); return; }
      var detail = action.hasAttribute('data-reminders-person-tell-us') ? 'tell' : 'request';
      if (detail === 'request') {
        one('[data-reminders-request-picks]').checked = action.hasAttribute('data-reminders-person-ask-wishlist');
        one('[data-reminders-request-address]').checked = action.hasAttribute('data-reminders-person-ask-address');
        one('[data-reminders-request-birthday]').checked = action.hasAttribute('data-reminders-person-ask-birthday');
      }
      showDrawer(detail, action); return;
    }
    if (event.target.closest('[data-reminders-detail-close]')) { event.preventDefault(); closeDrawer(); return; }
    var nextBudget = event.target.closest('[data-budget-cents]');
    if (nextBudget) { event.preventDefault(); selectBudget(Number(nextBudget.dataset.budgetCents)); return; }
    var range = event.target.closest('[data-budget-band]');
    if (range) { event.preventDefault(); selectBudget(range.dataset.budgetBand); return; }
    if (event.target.closest('[data-reminders-budget-browse]')) { event.preventDefault(); selectBudget(null); return; }
    if (event.target.closest('[data-reminders-detail-save]')) {
      event.preventDefault();
      var ideasField = one('[data-reminders-detail-ideas]');
      var notesField = one('[data-reminders-detail-notes]');
      var ideas = String(ideasField && ideasField.value || '').split('\n').map(function (line) { return line.trim(); }).filter(Boolean);
      if (ideas.length > 8 || ideas.some(function (idea) { return idea.length > 140; })) { error('Add up to eight ideas, each under 140 characters.'); return; }
      var notesText = String(notesField && notesField.value || '');
      var trimmed = notesText.trim();
      var unchanged = notesState.loaded && trimmed === String(notesState.text || '').trim();
      if (!unchanged) {
        var notesError = root.FBPersonNotes && root.FBPersonNotes.drawerError ? root.FBPersonNotes.drawerError(notesText) : (notesText.length > 800 ? 'Personal notes can be up to 800 characters.' : '');
        if (notesError) { error(notesError); return; }
      }
      saveTell(ideas, unchanged ? null : trimmed).then(function (okay) { if (okay) closeDrawer(); else error(one('[data-reminders-shop-save-status]').textContent); });
      return;
    }
    if (event.target.closest('[data-reminders-request-create]')) {
      event.preventDefault();
      if (!state || pending) return;
      var picks = one('[data-reminders-request-picks]').checked;
      var address = one('[data-reminders-request-address]').checked;
      var birthday = one('[data-reminders-request-birthday]').checked;
      if (!picks && !address && !birthday) { error('Choose at least one detail.'); return; }
      pending = true; error('');
      one('[data-reminders-request-create]').disabled = true;
      ['picks', 'address', 'birthday'].forEach(function (detail) { one('[data-reminders-request-' + detail + ']').disabled = true; });
      api.createRecipientRequest(state.occasion.friendId, { picks: picks, address: address, birthday: birthday }).then(function (response) {
        one('[data-reminders-request-url]').value = response.url;
        one('[data-reminders-request-share]').hidden = false;
        one('[data-reminders-request-url]').focus();
        refresh();
      }).catch(function (cause) { error(cause && cause.message || 'Could not make the link. Try again.'); }).finally(function () {
        pending = false;
        one('[data-reminders-request-create]').disabled = false;
        ['picks', 'address', 'birthday'].forEach(function (detail) { one('[data-reminders-request-' + detail + ']').disabled = false; });
      });
      return;
    }
    if (event.target.closest('[data-reminders-request-copy]')) {
      event.preventDefault(); var input = one('[data-reminders-request-url]'); input.focus(); input.select();
      if (root.navigator.clipboard && root.navigator.clipboard.writeText) root.navigator.clipboard.writeText(input.value).then(function () { error('Link copied.'); }).catch(function () { error('Select and copy the link above.'); });
      else error('Select and copy the link above.');
    }
  });
  page.addEventListener('change', function (event) {
    if (event.target.matches('[data-reminders-relationship]')) selectRelationship(event.target.value || '');
    if (event.target.matches('[data-reminders-request-picks], [data-reminders-request-address], [data-reminders-request-birthday]')) {
      one('[data-reminders-request-share]').hidden = true;
      one('[data-reminders-request-url]').value = '';
    }
  });
  root.document.addEventListener('click', function (event) {
    var plan = one('[data-reminders-shop-plan]');
    if (plan.open && !plan.contains(event.target)) plan.open = false;
  });
  root.document.addEventListener('keydown', function (event) {
    var plan = one('[data-reminders-shop-plan]');
    if (event.key === 'Escape' && plan.open) {
      plan.open = false;
      if (plan.contains(root.document.activeElement)) one('[data-reminders-budget-summary]').focus();
    }
    if (drawer.hidden) return;
    if (event.key === 'Escape') { closeDrawer(); return; }
    if (event.key !== 'Tab') return;
    var focusables = Array.from(drawer.querySelectorAll('button, input, textarea, select, a[href]')).filter(function (item) { return !item.disabled && item.offsetParent !== null; });
    if (!focusables.length) return;
    var first = focusables[0], last = focusables[focusables.length - 1];
    if (event.shiftKey && root.document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && root.document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  refresh();
})(window);
